<template>
	<div :style="`animation-delay: ${index * 0.04}s`" class="template-card">
		<component :is="linkOn ? 'router-link' : 'div'" :to="`${templateRoute}`" class="template-card__container">
			<div
				v-if="template.isCognitoAICard"
				class="template-card__image flex flex--align bg-midnight"
			>
				<CognitoAi />
			</div>
			<div
				v-else
				class="template-card__image bg-shade-3 relative"
			>
				<img loading="lazy" :src="template.thumbnail" alt="" />
			</div>
			<h3 class="template-card__content mt-2 sz-3 heavy text-primary">{{ template.title }}</h3>
		</component>
	</div>
</template>

<script>
	import componentMountedEvent from '../../mixins/content-component-mounted-event';
	import CognitoAi from './CognitoAI.vue';
	import { urlize } from '@cognitoforms/utils/utilities';

	export default {
		name: 'Card',
		components: {
			CognitoAi
		},
		mixins: [componentMountedEvent],
		props: {
			tag: {
				type: String,
				default: ''
			},
			template: {
				type: Object,
				required: true
			},
			index: {
				type: Number,
				required: true
			},
			linkOn: {
				type: Boolean,
				default: true
			}
		},
		computed: {
			cfid() {
				return this.template.cfid;
			},
			templateRoute() {
				let templateURL =
					this.tag
						? this.template.route.replace(`/${this.cfid}`, `/${this.cfid}/${urlize(this.tag)}`)
						: this.template.route;

				const folderQuery = this.$route.params.folder ?? this.$route.query.folder;
				if (folderQuery)
					templateURL += `?folder=${folderQuery}`;

				return templateURL;
			}
		}
	};
</script>

<style lang="scss">
.template-card {
	opacity: 0;
	animation: fade-in .7s cubic-bezier(.42, 0, 0, 1.5) forwards;
	transition: all .5s;

	&__image {
		height: 10em;
		border: 1px solid var(--border-primary);
		overflow: hidden;

		img {
			transition: transform 1s;
		}
	}

	h3 {
		transition: color .25s;
	}

	&:hover,
	&:focus {

		.template-card__image img {
			transform: translateY(calc(-100% + 10em));
			transition: transform 5s;
		}

		h3 {
			color: var(--accent-7);
		}
	}

	@keyframes fade-in {

		0% {
			opacity: 0;
			transform: scale(1.1);
		}

		100% {
			opacity: 1;
		}
	}
}
</style>